// project-imports
import {
    GET_LOGIN_BEGIN,
    GET_LOGIN_FAILURE,
    GET_LOGIN_STATUS_BEGIN,
    GET_LOGIN_STATUS_FAILURE,
    GET_LOGIN_STATUS_SUCCESS,
    GET_LOGIN_SUCCESS,
    GET_SIGNOUT_BEGIN,
    GET_SIGNOUT_FAILURE,
    GET_SIGNOUT_SUCCESS,
    GET_SIGNUP_BEGIN,
    GET_SIGNUP_FAILURE,
    GET_SIGNUP_SUCCESS,
    POST_FORGOT_PASSWORD_BEGIN,
    POST_FORGOT_PASSWORD_FAILURE,
    POST_FORGOT_PASSWORD_SUCCESS,
    POST_RESET_PASSWORD_BEGIN,
    POST_RESET_PASSWORD_FAILURE,
    POST_RESET_PASSWORD_SUCCESS,
    CHECK_USERNAME_AVAILABILITY_BEGIN,
    CHECK_USERNAME_AVAILABILITY_FAILURE,
    CHECK_USERNAME_AVAILABILITY_SUCCESS,
    UPDATE_USER_PROFILE_BEGIN,
    UPDATE_USER_PROFILE_SUCCESS,
    UPDATE_USER_PROFILE_FAILURE,
} from "../constants/actions";

// State variable initialization
export const initialState = {
    isLoading: false,
    isCheckUsernameLoading: false,
    error: null,
    loginData: [],
    userData: [],
}

const userReducer = (state = initialState, action) => {

    if (action.type === GET_LOGIN_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            error: null
        }
    }

    if (action.type === GET_LOGIN_SUCCESS) {

        // Update state with login data
        return {
            ...state,
            isLoading: false,
            loginData: action.payload,
            error: null
        };
    }

    if (action.type === GET_LOGIN_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            error: action.payload,
        }
    };

    if (action.type === GET_SIGNOUT_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            error: null
        }
    }

    if (action.type === GET_SIGNOUT_SUCCESS) {

        // Update state with signout data
        return {
            ...state,
            isLoading: false,
            loginData: action.payload,
            error: null
        };
    }

    if (action.type === GET_SIGNOUT_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            error: action.payload,
        }
    };

    if (action.type === GET_SIGNUP_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            error: null
        };
    }

    if (action.type === GET_SIGNUP_SUCCESS) {

        // Update state with signup data
        return {
            ...state,
            isLoading: false,
            userData: action.payload,
        };
    }

    if (action.type === GET_SIGNUP_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            error: action.payload,
        }
    }

    // check-login-status
    if (action.type === GET_LOGIN_STATUS_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            error: null
        }
    }

    if (action.type === GET_LOGIN_STATUS_SUCCESS) {

        // Update state with login data
        return {
            ...state,
            isLoading: false,
            loginData: action.payload,
            error: null
        };
    }

    if (action.type === GET_LOGIN_STATUS_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            loginData: [],
            error: action.payload,
        }
    };

    // forgot-password
    if (action.type === POST_FORGOT_PASSWORD_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            error: null
        }
    }

    if (action.type === POST_FORGOT_PASSWORD_SUCCESS) {
        // Update state with login data
        return {
            ...state,
            isLoading: false,
            loginData: [],
            error: null
        };
    }

    if (action.type === POST_FORGOT_PASSWORD_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            error: action.payload,
        }
    };

    // reset-password
    if (action.type === POST_RESET_PASSWORD_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            error: null
        }
    }

    if (action.type === POST_RESET_PASSWORD_SUCCESS) {
        // Update state with login data
        return {
            ...state,
            isLoading: false,
            loginData: [],
            error: null
        };
    }

    if (action.type === POST_RESET_PASSWORD_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            error: action.payload,
        }
    };

    // chechk username-availability
    if (action.type === CHECK_USERNAME_AVAILABILITY_BEGIN) {
        // Set loading state
        return {
            ...state,
            isCheckUsernameLoading: action.payload,
            error: null
        }
    }

    if (action.type === CHECK_USERNAME_AVAILABILITY_SUCCESS) {
        // Update state 
        return {
            ...state,
            isCheckUsernameLoading: false,
            error: null
        };
    }

    if (action.type === CHECK_USERNAME_AVAILABILITY_FAILURE) {
        // Set error state
        return {
            ...state,
            isCheckUsernameLoading: false,
            error: action.payload,
        }
    };

    if (action.type === UPDATE_USER_PROFILE_BEGIN) {
        // Set loading state
        return {
            ...state,
            isLoading: action.payload,
            error: null
        }
    }

    if (action.type === UPDATE_USER_PROFILE_SUCCESS) {

        // Update state with login data
        return {
            ...state,
            isLoading: false,
            loginData: action.payload,
            error: null
        };
    }

    if (action.type === UPDATE_USER_PROFILE_FAILURE) {
        // Set error state
        return {
            ...state,
            isLoading: false,
            error: action.payload,
        }
    };
    return state;
}
export default userReducer;